<!-- ====#PAGE LOADER====-->
<span class="page-loader" [class.loaded]="pageLoader"></span>
<!-- ====#ENDPAGE LOADER====-->
<router-outlet></router-outlet>